import React, { useCallback, useEffect, useState} from "react";
import {
  Typography,
  Box,
  TextField,
  Autocomplete,
  Tabs,
  Tab,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import { useHistory, useLocation } from "react-router";
import { ROUTE_PATHS } from "src/routes";
import { DeadCatalogDetailTab } from "./catalog_detail_tab/DeadCatalogDetailTab";
import { AddDeadCatalog } from '../modals/AddDeadCatalog';
import CloseIcon from '@mui/icons-material/Close';
import { deleteModalStyle, modalStyle } from "src/shared/Styles/Styles";
import { getDeadCatalogsCall } from "src/apis/getCatalogCalls";
import { useStoreContext } from "src/store/context";
import { useAddAlert } from "src/store/actions";
import { alertMessages } from "src/constants";
import { DeleteCatalog } from "../modals/DeleteCatalog";
import { checkAdminRole } from "src/store/common";
import { AuditCatalog } from "./catalog_audits/AuditCatalog";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box >{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function DeadCatalogDetail({tab}) {
  const history = useHistory();
  const location = useLocation();
  const [state, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);

  const [tabValue, setTabValue] = useState(tab);
  const [deadCatalog, setDeadCatalog] = useState<any>(null);
  const [routes, setRoutes ] = useState<string[]>([]);
  const [searchedDeadCatalog, setSearchedDeadCatalog] = useState<any>(null);
  const [searchOptions, setSearchOptions] = useState<any[]>([])
  
  const [openDeadModal, setOpenDeadModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [createUpdateDeadSuccess, setCreateUpdateDeadSuccess] = useState<boolean>(false);
  const [deleteFuelCatalogSuccess, setDeleteFuelCatalogSuccess] = useState<boolean>(false);
  const [editDeadFuel, setEditDeadFuel] = useState<string>('');

  /** Make the api call for the dead catalog detail */
  const deadCatalogCallback = useCallback((request: any, search?: boolean) => {
    (async () => {
      try {
        const deadCatalogResponse: any = await getDeadCatalogsCall(request, addAlert);
        if (deadCatalogResponse.data.length > 0) {
          if (search) {
            setSearchOptions(deadCatalogResponse.data)
          }
          else {
            setDeadCatalog(deadCatalogResponse.data[0]);
          }
          
        } else {
          search ? setSearchOptions([]) : setDeadCatalog(null);
        }
        setCreateUpdateDeadSuccess(false)

      } catch (error) {
        search ? setSearchOptions([]) : setDeadCatalog(null);
        setCreateUpdateDeadSuccess(false)
        addAlert({
          id: '',
          message: alertMessages.retrieveCatalog,
          type: 'error-info',
          icon: 'fa-exclamation-triangle'
        });
      }
    })();
  }, [addAlert]);

  const clickViewAllDeadCatalogs = useCallback(()=>{
    history.push({
      pathname: `${ROUTE_PATHS.table}${ROUTE_PATHS.deadTab}`,
      state: {...deadCatalog, page: 0, perPage: 10}
    })
  }, [history, deadCatalog]);

  useEffect(()=>{
    if(location?.state){
      const thisDeadCatalog:any = location.state;
      if(thisDeadCatalog.from){
        setSearchedDeadCatalog(thisDeadCatalog)
      }
      setDeadCatalog(thisDeadCatalog);
      setEditDeadFuel(thisDeadCatalog?.id)
      setRoutes([`${ROUTE_PATHS.table}${ROUTE_PATHS.deadTab}/detail/${thisDeadCatalog?.id}`, 
      `${ROUTE_PATHS.table}${ROUTE_PATHS.deadTab}/audit/${thisDeadCatalog?.id}`
      ])
    }
    else{
      const stringArray = decodeURIComponent(location.pathname).split("/");
      const catalogId = stringArray[stringArray?.length-1];
      const request = {
        id: Number(catalogId),
        perPage: 10000,
        page: 0,
        sortBy: 'dead_fuel_parameter_catalog_name',
        sortOrder: 'asc',
      }
      deadCatalogCallback(request);
      setRoutes([`${ROUTE_PATHS.table}${ROUTE_PATHS.deadTab}/detail/${catalogId}`, 
      `${ROUTE_PATHS.table}${ROUTE_PATHS.deadTab}/audit/${catalogId}`
      ])
    }
  },[location?.pathname, location.state, deadCatalogCallback])

  /* call to get search options*/
  useEffect(() => {
    const requestSearch = {
      id: null,
      catalogName: null,
      perPage: 10000,
      page: 0,
      sortBy: 'dead_fuel_parameter_catalog_name',
      sortOrder: 'asc',
    }
    deadCatalogCallback(requestSearch, true)
  }, [deadCatalogCallback]);

  /*successful save or update or delete*/
  useEffect(() => {
    if(createUpdateDeadSuccess){
      const request = {
        id: Number(deadCatalog.id),
        perPage: 10000,
        page: 0,
        sortBy: 'dead_fuel_parameter_catalog_name',
        sortOrder: 'asc',
      }
      deadCatalogCallback(request);
      //call for search options
      const requestSearch = {
        id: null,
        catalogName: null,
        perPage: 10000,
        page: 0,
        sortBy: 'dead_fuel_parameter_catalog_name',
        sortOrder: 'asc'
      }
      deadCatalogCallback(requestSearch, true);
    } else if (deleteFuelCatalogSuccess) {
      clickViewAllDeadCatalogs();
    }
  }, [deadCatalogCallback, createUpdateDeadSuccess, deleteFuelCatalogSuccess, deadCatalog, clickViewAllDeadCatalogs]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    history.push({
      pathname: `${routes[newValue]}`,
      state: {...deadCatalog}
    });
  };
 
  const handleCloseDeadModal = (_event: any, reason: any) => {
    if (reason && reason === "backdropClick") {
      setOpenDeadModal(false);
    }
    setOpenDeadModal(false);
    setEditDeadFuel('')
  }
  
  const onDeadCatalogSearch = (e: React.SyntheticEvent<Element, Event>, incomingVal: any) => {
    history.push(
      { pathname: `${ROUTE_PATHS.table}${ROUTE_PATHS.deadTab}/detail/${incomingVal?.id}`, state: { ...incomingVal, from: 'search' } }
    )
  }

  const handleDeleteCatalog = () => {
    setOpenDeleteModal(true);
  }
  
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  }

  return (
    <Box>
      <Modal //Modal to open edit/create dead
        className="smooth-scrollbar"
        open={openDeadModal}
        onClose={handleCloseDeadModal}
      >
        <div>
          <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenDeadModal(false) }}>
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding" >
            {
              <AddDeadCatalog setOpen={setOpenDeadModal} setCreateUpdateDeadSuccess={setCreateUpdateDeadSuccess} editDead={editDeadFuel}/>
            }
          </Box>
        </div>
      </Modal>
      <Modal //Modal to delete catalog
        className="smooth-scrollbar"
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
      >
        <div style={{ height: '100%' }}>
          <IconButton aria-label='close' style={{ left: '64%', top:'23.5%', position: 'absolute', cursor: 'pointer' }} onClick={(e)=>handleCloseDeleteModal()} >
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={deleteModalStyle} className="smooth-scrollbar removePadding" >
            { state.user && checkAdminRole(state.user) &&
              <DeleteCatalog setOpenDeleteModal={setOpenDeleteModal} setDeleteFuelCatalogSuccess={setDeleteFuelCatalogSuccess} deleteCatalogId={deadCatalog?.id} catalogName={deadCatalog?.catalogName} catalogCategory={'Dead'}/>
            }
          </Box>
        </div>
      </Modal>

      {/* Toolbar */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 2,
        }}
      >
        {/* Left Section */}
        <Box sx={{display: 'flex', flexDirection:'column'}}>
          <Typography variant="h5">
            <span style={{marginRight: '1rem', textTransform:'capitalize'}}>{deadCatalog?.catalogName}</span> 
            <Button variant="contained" onClick={()=> {setOpenDeadModal(true)}}>Edit Catalog</Button>
            { deadCatalog?.id !== 1 &&
            <Button variant="contained" color='error' style={{marginLeft:'1rem'}} onClick={()=>handleDeleteCatalog()}>Delete Catalog</Button>
            }
          </Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", flexDirection: "column", marginRight: '1rem',alignItems: "flex-end", width: '25vw' }}>
          <div className="searchStationsDownloadPage">
            {/* Search Icons */}
            <i className="fas fa-search"/>
            <Autocomplete
              id="deadDetailCatalogSearch"
              clearOnEscape
              freeSolo
              noOptionsText={
                <div className='no-results'>
                    <div>No results match your search criteria.</div>
                </div>
              }
              options={searchOptions}
              getOptionLabel={(option)=>`${option.catalogName}`}           
              aria-label="deadDetailCatalogSearch"
              value={searchedDeadCatalog}
              onChange={(event, newValue) => onDeadCatalogSearch(event, newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Search Dead Fuel Catalogs...'}
                  placeholder="Search Dead Fuel Catalogs..."
                />
              )}
            />
          </div>
          <Box mt={1}>
            <Button variant='text' onClick={clickViewAllDeadCatalogs} className="font-sans-sm text-bold" style={{ color: "#1675e0", textTransform:'capitalize' }}>
              View All Dead Fuel Catalogs
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Tabs Section */}
      <Box sx={{ width: "100%", marginTop: 3 }}>
        <Box>
        {/* Tabs Section */}
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="custom tabs example"
            className="tabcatalog"
          >
            <Tab label="Details" {...a11yProps(0)} />
            <Tab label="Audit Logs" {...a11yProps(1)} />

          </Tabs>
        </Box>
        {/* Tab Panels */}
        <CustomTabPanel value={tabValue} index={0}>
          <div style={{backgroundColor: '#dddddd', height: '60vh'}}>
            <DeadCatalogDetailTab deadCatalog={deadCatalog}/>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <div style={{backgroundColor: '#eeeeee', height: '100%'}}>
            <AuditCatalog catalogType={'Dead'}/>
          </div>
        </CustomTabPanel>
      </Box>

    </Box>
  );
}

export default DeadCatalogDetail;